import { createLogger } from "@account-kit/logging";
import { VERSION } from "./version.js";
export const ReactLogger = createLogger({
    package: "@account-kit/react",
    version: VERSION,
});
//# sourceMappingURL=metrics.js.map